import React from 'react';
import Modal from './Modal';

class InformationModal extends React.PureComponent {

    render() {

        return (

            <Modal show={this.props.show} title="About GrowApp" onClose={this.props.onClose}>

                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

            </Modal>
        );
    }
}

export default InformationModal;



// WEBPACK FOOTER //
// ./src/components/modals/InformationModal.js